import Repository from './Repository';
import { DeviceModel } from '@/store/types';

const resource: string = '/devices';

export class DevicesRepository {
  // public static create(name: string, kind: string, networkId: string) {
  public static create(name: string, kind: string) {
    // const payload = { name, kind, networkId };
    const payload = { name, kind };
    return Repository.post(`${resource}`, payload);
  }

  public static getAll() {
    return Repository.get<DeviceModel[]>(`${resource}`);
  }

  public static get(deviceId: string) {
    return Repository.get<DeviceModel>(`${resource}/${deviceId}`);
  }

  public static put(device: DeviceModel, keys: string[]) {
    // const payload = { name: device.name, kind: device.kind, networkId: device.networkId };
    const payload = { device_id: device.deviceId };
    for (const key of keys) {
      payload[key] = device[key];
    }
    return Repository.put(`${resource}`, payload);
  }

  public static delete(deviceId: string) {
    return Repository.delete(`${resource}/${deviceId}`);
  }
}
